import { useState } from 'react';

import { Field, FormRenderProps, FormMeta, ValidateTrigger } from '@flowgram.ai/free-layout-editor';

import { getFieldValue, setFieldValue } from '../../utils/common';
import { FlowNodeJSON } from '../../typings';
import { useIsSidebar } from '../../hooks';
import { CodeEditor } from '../../form-components/form-inputs';
import { FormHeader, FormContent, FormOutputs, FormItem } from '../../form-components';
// CodeMirror styles are now handled by @uiw/react-codemirror

export const renderForm = ({ form }: FormRenderProps<FlowNodeJSON>) => {
  const isSidebar = useIsSidebar();
  const [jsCode, setJsCode] = useState(getFieldValue('jsCode', form) || '');

  if (isSidebar) {
    return (
      <>
        <FormHeader />
        <FormContent>
          <Field
            name="jsCode"
            render={() => (
              <CodeEditor
                value={jsCode}
                mode={{ name: 'javascript', json: true }}
                placeholder="请输入 JavaScript 代码..."
                enableFormat={true}
                autoHeight={true}
                onChange={(value) => {
                  setJsCode(value);
                  setFieldValue('jsCode', value, form);
                }}
              />
            )}
          />
        </FormContent>
      </>
    );
  }
  return (
    <>
      <FormHeader />
      <FormContent>
        <FormOutputs />
        <Field
          name="fields"
          render={() => (
            <FormItem name="JS Code" type="string">
              {jsCode}
            </FormItem>
          )}
        />
      </FormContent>
    </>
  );
};

export const formMeta: FormMeta<FlowNodeJSON> = {
  render: renderForm,
  validateTrigger: ValidateTrigger.onChange,
  validate: {
    title: ({ value }: { value: string }) => (value ? undefined : 'Title is required'),
    fields: ({ value }) => {
      if (!value[0].value) return 'JS 代码不能为空';
      return undefined;
    },
  },
};
